class QuotationMobileIntro {
    /** @ngInject */
    constructor(DeviceChecker) {
        this.isMobile = DeviceChecker.isMobile
        this.currentSlide = 0
    }

    nextSlide() {
        this.currentSlide = this.currentSlide + 1
    }

    hideMobileIntro() {
        this.onDispatch({ $event: { type: 'HIDE_MOBILE_INTRO' } })
    }
}

export default {
    template: require('./quotationMobileIntro.jade')(),
    controller: QuotationMobileIntro,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationMobileIntro.js